/* FAROSOL — interacciones propias (prefijo mt-) */
(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  // 9 · Foco que sigue al cursor en el héroe
  function initHeroes(raiz) {
    (raiz || document).querySelectorAll('[data-mt-hero]').forEach(function (hero) {
      if (hero.dataset.mtInit) return; hero.dataset.mtInit = '1';
      if (reducido || window.matchMedia('(hover: none)').matches) return;
      var foco = hero.querySelector('.mt-hero-foco');
      if (!foco) return;
      var pendiente = false, x = 68, y = 52;
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        x = ((ev.clientX - r.left) / r.width) * 100;
        y = ((ev.clientY - r.top) / r.height) * 100;
        if (pendiente) return; pendiente = true;
        requestAnimationFrame(function () {
          foco.style.setProperty('--mx', x + '%');
          foco.style.setProperty('--my', y + '%');
          pendiente = false;
        });
      });
    });
  }

  // 17 · Puntos sobre el producto
  function initHotspots(raiz) {
    (raiz || document).querySelectorAll('[data-mt-hotspots]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var puntos = sec.querySelectorAll('.mt-punto');
      var items = sec.querySelectorAll('.mt-hot-lista li');
      function activar(i) {
        puntos.forEach(function (p, j) { p.classList.toggle('mt-activo', j === i); p.querySelector('button').setAttribute('aria-expanded', j === i); });
        items.forEach(function (li, j) { li.classList.toggle('mt-activo', j === i); });
      }
      puntos.forEach(function (p, i) {
        p.querySelector('button').addEventListener('click', function (e) {
          e.stopPropagation();
          activar(p.classList.contains('mt-activo') ? -1 : i);
        });
      });
      items.forEach(function (li, i) {
        li.addEventListener('click', function () { activar(i); });
        li.addEventListener('mouseenter', function () { activar(i); });
      });
      document.addEventListener('click', function (e) { if (!sec.contains(e.target)) activar(-1); });
    });
  }

  // 77 · Selector de escenario
  function initEscenarios(raiz) {
    (raiz || document).querySelectorAll('[data-mt-escenarios]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var tabs = sec.querySelectorAll('.mt-esc-tab');
      var paneles = sec.querySelectorAll('.mt-esc-panel');
      var intervalo = parseInt(sec.dataset.auto || '0', 10) * 1000;
      var actual = 0, timer = null;
      function ir(i) {
        actual = i;
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i); t.tabIndex = j === i ? 0 : -1; });
        paneles.forEach(function (p, j) { p.classList.toggle('mt-activo', j === i); p.setAttribute('aria-hidden', j !== i); });
      }
      function arrancar() {
        if (!intervalo || reducido) return;
        clearInterval(timer);
        timer = setInterval(function () { ir((actual + 1) % tabs.length); }, intervalo);
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { ir(i); arrancar(); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
            ir(n); tabs[n].focus(); arrancar();
          }
        });
      });
      sec.addEventListener('mouseenter', function () { clearInterval(timer); });
      sec.addEventListener('mouseleave', arrancar);
      arrancar();
    });
  }

  // 86 · Día / noche
  function initDiaNoche(raiz) {
    (raiz || document).querySelectorAll('[data-mt-dianoche]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var botones = sec.querySelectorAll('[data-modo-boton]');
      var modos = sec.querySelectorAll('.mt-dn-modo');
      var tocado = false;
      function poner(modo) {
        sec.dataset.modo = modo;
        botones.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.modoBoton === modo); });
        modos.forEach(function (m) { m.classList.toggle('mt-activo', m.dataset.modo === modo); });
      }
      botones.forEach(function (b) { b.addEventListener('click', function () { tocado = true; poner(b.dataset.modoBoton); }); });
      // Al entrar en pantalla, anochece solo una vez para enseñar el efecto
      if (!reducido && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) {
            io.disconnect();
            setTimeout(function () { if (!tocado) poner('noche'); }, 1800);
          }
        }, { threshold: 0.5 });
        io.observe(sec);
      }
    });
  }

  // 80 · Preguntas frecuentes
  function initFaq(raiz) {
    (raiz || document).querySelectorAll('[data-mt-faq]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      sec.querySelectorAll('.mt-faq-pregunta').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.mt-faq-item');
          var abierto = item.classList.toggle('mt-abierto');
          btn.setAttribute('aria-expanded', abierto);
        });
      });
    });
  }

  // Página de producto: galería, variantes, cantidad y barra fija en móvil
  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var principal = sec.querySelector('.mt-galeria-principal img');
      var minis = sec.querySelectorAll('.mt-miniatura');
      function verFoto(src, alt, boton) {
        if (!principal || !src) return;
        principal.style.opacity = 0;
        setTimeout(function () { principal.src = src; principal.removeAttribute('srcset'); principal.alt = alt || ''; principal.style.opacity = 1; }, 180);
        minis.forEach(function (m) { m.setAttribute('aria-current', m === boton); });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { verFoto(m.dataset.src, m.dataset.alt, m); }); });

      var datos = sec.querySelector('[data-mt-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var inputId = sec.querySelector('input[name="id"]');
      var precioEls = sec.querySelectorAll('[data-mt-precio]');
      var tachadoEls = sec.querySelectorAll('[data-mt-tachado]');
      var botonesCompra = sec.querySelectorAll('[data-mt-comprar]');
      var formato = sec.dataset.formato || '{{amount}}';
      function dinero(cent) {
        var v = (cent / 100);
        var con2 = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        var sin = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        var coma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
        return formato.replace(/\{\{\s*amount_no_decimals\s*\}\}/, sin)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
          .replace(/\{\{\s*amount\s*\}\}/, con2);
      }
      function actualizar() {
        var sel = [];
        sec.querySelectorAll('.mt-variante-opciones').forEach(function (g) {
          var c = g.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        precioEls.forEach(function (el) { el.textContent = dinero(v.price); });
        tachadoEls.forEach(function (el) {
          if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = dinero(v.compare_at_price); el.hidden = false; }
          else el.hidden = true;
        });
        botonesCompra.forEach(function (b) {
          b.disabled = !v.available;
          var t = b.querySelector('[data-texto]');
          if (t) t.textContent = v.available ? b.dataset.textoDisponible : b.dataset.textoAgotado;
        });
        if (v.featured_image && v.featured_image.src) verFoto(v.featured_image.src, v.featured_image.alt, null);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      }
      sec.querySelectorAll('.mt-variante-opciones input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var cant = sec.querySelector('.mt-cantidad input');
      sec.querySelectorAll('[data-mt-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.dataset.mtCant, 10));
          cant.value = n;
        });
      });

      var barra = sec.querySelector('.mt-sticky-compra');
      var formulario = sec.querySelector('.mt-prod-form');
      if (barra && formulario && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          barra.classList.toggle('mt-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(formulario);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () { formulario.querySelector('[data-mt-comprar]').click(); });
      }
    });
  }

  function initTodo(e) {
    var raiz = e && e.target && e.target.nodeType === 1 ? e.target : document;
    initReveals(raiz); initHeroes(raiz); initHotspots(raiz); initEscenarios(raiz);
    initDiaNoche(raiz); initFaq(raiz); initProducto(raiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
